  <ng-container *ngIf="m.alreadyExists(dataItem, primaryKeyName)">
    <aims-file-upload
                [allowedFileType]="fileRestrictions"
                [maxFileSize]="maxFileSize"
                [saveUrl]="saveUrl + '?' + primaryKeyName + '=' + dataItem[primaryKeyName]"
                (success)="success.emit($event)">
    ></aims-file-upload>
  </ng-container>

  <span *ngIf="!m.alreadyExists(dataItem, primaryKeyName)" style="color:red">Not Saved!</span>
